import { PortfolioEngineAccount, TradingStatus } from '@ndvr/portfolio-api';

export const getOnboardEligibility = (selectedAccounts: PortfolioEngineAccount[]) => {
    const onboardableAccounts = selectedAccounts.filter((account) => account.tradingStatus === TradingStatus.MANUAL);
    const allEligible = onboardableAccounts.length === selectedAccounts.length;
    const hasMultipleTenants = new Set(selectedAccounts.map((account) => account.tenantGUID)).size > 1;
    const canOnboard = selectedAccounts.length > 0 && allEligible && !hasMultipleTenants;
    const onboardDisabledReason =
        selectedAccounts.length > 0 && hasMultipleTenants
            ? 'Onboarding is only available for accounts from a single tenant.'
            : selectedAccounts.length > 0 && !allEligible
              ? 'Onboarding is only available for accounts with Manual trading status.'
              : null;
    return { onboardableAccounts, canOnboard, onboardDisabledReason };
};
